export default {
    video_wakingCamera: 'Estableciendo conexión con la cámara...',
    video_stopingCamera: 'Finalizando transmisión en vivo...',
    video_stoppedCamera: 'Transmisión finalizada',
    video_errorApi: 'No se pudo cargar el video, por favor intente de nuevo.',
    video_snapshotErrorApi: 'No se pudo cargar la imagen, por favor intente de nuevo.',
    video_retryMessage: 'El video no se pudo cargar, ya sea porque el servidor o la red fallaron, por favor intente de nuevo.',
    video_cameraOffline: 'La cámara está desconectada',
    video_360Message: 'Utilice el mouse para arrastrar y soltar el video',
    video_errorAccessDenied: 'No se pudo cargar el video, acceso denegado',
    video_timeout: "Se agotó el tiempo de espera del video en vivo.",
    video_unableToLiveStream: 'El vehículo está actualmente fuera de línea: no se puede transmitir en vivo',
    video_uploading: "Cargando fotos en vivo...",
    video_firmwareNotSupport: "Funcionalidad no soportada",
    video_sdCardError: "Error de tarjeta SD",
    video_failed: "No hay ningún clip disponible en el rango de tiempo seleccionado. Intente de nuevo",
    video_downloadingClip: "Descargando video...",
    video_privatecliprequest: "Solicitud de clip privado",
    video_privatecliprequest_tooltip:
      "Si marcas esto, el video solo será visible para ti.",
  }